import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { putRequest } from "../services/apiMethods";
import toast from "react-hot-toast";

export default function ShopDetail({ store, onClose, getStores }) {
  const navigate = useNavigate();
  const [localLoading, setLocalLoading] = useState(false);
  const userId = sessionStorage.getItem("userId");
  const storeid = sessionStorage.getItem("storeid");
  const [loaded, setLoaded] = useState(false);

  const { mutate, isLoading } = useMutation({
    mutationFn: (data) => putRequest(`/user/update/${userId}`, data),
    onMutate: () => setLocalLoading(true),
    onSuccess: (data) => {
      navigate(`/set-password`);
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
    onSettled: () => setLocalLoading(false),
  });

  const handleSubmit = () => {
    const payload = {
      preferedStoreId: store?._id,
    };
    mutate(payload);
  };

  const preferredStore = getStores?.stores?.find((s) => s._id === storeid);

  return (
    <>
      <div className="popup-overlay">
        <div className="popup-content p-0" style={{ position: "relative" }}>
          <button
            className="close-btn text-white rounded-circle"
            onClick={onClose}
            style={{
              backgroundColor: "#e58d2e",
              width: "38px",
              height: "38px",
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 10,
              border:'1px solid '
            }}
          >
            X
          </button>

          <div className="shop-card-theme">
            {/* Shimmer wrapper ONLY for cover image */}
            <div
              style={{
                width: "100%",
                height: "200px",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                background: loaded
                  ? "transparent"
                  : "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: loaded ? "none" : "shimmer 1.5s linear infinite",
                overflow: "hidden",
              }}
            >
              <img
                src={
                  preferredStore?.coverPhoto
                    ? preferredStore.coverPhoto
                    : require("../Assets/images/shop-bg.png")
                }
                alt="cover"
                onLoad={() => setLoaded(true)}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: loaded ? "block" : "none",
                }}
              />
            </div>

            {/* Shimmer Keyframes */}
            <style>
              {`
                @keyframes shimmer {
                  0% { background-position: -200% 0; }
                  100% { background-position: 200% 0; }
                }
              `}
            </style>

            {/* Shop details stay untouched */}
            <div className="shop-detail-view">
              <img
                src={
                  preferredStore?.logo
                    ? preferredStore.logo
                    : require("../Assets/images/logo-main.png")
                }
                alt="logo"
                className="shop-logo"
              />
              <h2>{store?.name}</h2>
              <p>{store?.bio}</p>
              <h3>Address</h3>
              <p>
                {store?.address?.firstLine}
                <br />
                {store?.address?.secondLine}
                <br />
                {store?.address?.townORcity}
                <br />
                {store?.address?.postcode}
              </p>

              <div>
                <p>Get your daily coﬀee from as little as £1.65 per day</p>
                <button onClick={() => handleSubmit()}>
                  Set Preferred Store
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
